<div class="contenedor {{ responsiveService.claseCSS$ | async }}">
  <ng-container *ngFor="let elemento of NAVEGACION">
    <a
      *autorizacion="elemento.autorizacion"
      class="elemento"
      [routerLink]="elemento.url"
    >
      <div class="icono {{ elemento.imagen }}">
        <img class="imagen" src="assets/icons/{{ elemento.imagen }}.png" />
        <img class="animacion" src="assets/icons/{{ elemento.imagen }}.gif" />
      </div>
      <!-- <button mat-fab color="primary">
          <mat-icon>{{ elemento.icono }}</mat-icon>
        </button> -->
      <p>{{ elemento.nombre }}</p>
    </a>
  </ng-container>
</div>
